/* AthleteSwap Fit — Engine
   1:1 portiert aus lib/fit/engine.ts. Grundregel: Ohne belegte Regel keine
   Größe. Lieber "dazu fehlen uns Daten" als eine Zahl, nach der jemand
   Ausrüstung fürs Kind kauft. Zweite Regel: eine Empfehlung je Marke, weil
   Hersteller unterschiedlich messen. Braucht window.AsFitDaten. */
(function () {
  var RANDZONE_MM = 3;
  var RANDZONE_CM = 1;

  function zahl(werte, schluessel) {
    var w = werte[schluessel];
    return typeof w === "number" && isFinite(w) ? w : null;
  }

  function laengererFuss(werte) {
    var l = zahl(werte, "fussLinksMm");
    var r = zahl(werte, "fussRechtsMm");
    if (l === null && r === null) return null;
    return Math.max(l || 0, r || 0);
  }

  function mmAlsCm(mm) {
    return (mm / 10).toFixed(1).replace(".", ",");
  }

  function bereichPruefen(wert, von, bis, randzone) {
    if (wert < von || wert > bis) return "ungeeignet";
    if (wert - von < randzone || bis - wert < randzone) return "grenze";
    return "passt";
  }

  var RANG = { passt: 0, grenze: 1, pruefen: 2, ungeeignet: 3 };

  function schlechteste(bewertungen) {
    var schlimmste = "passt";
    for (var i = 0; i < bewertungen.length; i++) {
      if (RANG[bewertungen[i]] > RANG[schlimmste]) schlimmste = bewertungen[i];
    }
    return schlimmste;
  }

  var BEWERTUNG_TEXT = {
    passt: { kurz: "Sehr passend", lang: "Alle Maße liegen im empfohlenen Bereich." },
    grenze: { kurz: "Kann passen", lang: "Ein Wert liegt dicht an der Grenze des Bereichs — hier lohnt der genaue Blick." },
    pruefen: { kurz: "Bitte genauer prüfen", lang: "Für eine sichere Aussage fehlen Angaben." },
    ungeeignet: { kurz: "Eher nicht passend", lang: "Die Maße liegen außerhalb des Bereichs dieser Größe." }
  };

  function regelPruefen(regel, werte) {
    var bewertungen = [];
    var fehlend = [];
    for (var schluessel in regel.bereiche) {
      if (!Object.prototype.hasOwnProperty.call(regel.bereiche, schluessel)) continue;
      var bereich = regel.bereiche[schluessel];
      if (!bereich) continue;
      var wert = zahl(werte, schluessel);
      if (wert === null) {
        fehlend.push(schluessel);
        continue;
      }
      var randzone = /Mm$/.test(schluessel) ? RANDZONE_MM : RANDZONE_CM;
      bewertungen.push(bereichPruefen(wert, bereich.von, bereich.bis, randzone));
    }
    if (fehlend.length > 0 || bewertungen.length === 0) {
      return { passt: false, bewertung: "pruefen", fehlend: fehlend };
    }
    var gesamt = schlechteste(bewertungen);
    return { passt: gesamt !== "ungeeignet", bewertung: gesamt, fehlend: fehlend };
  }

  function besteRegel(regelsatz, werte) {
    var treffer = null;
    for (var i = 0; i < regelsatz.groessen.length; i++) {
      var regel = regelsatz.groessen[i];
      var ergebnis = regelPruefen(regel, werte);
      if (!ergebnis.passt) continue;
      if (ergebnis.bewertung === "passt") return { regel: regel, bewertung: ergebnis.bewertung };
      if (!treffer) treffer = { regel: regel, bewertung: ergebnis.bewertung };
    }
    return treffer;
  }

  function auswerten(kategorie, werte) {
    var daten = window.AsFitDaten;
    var kat = daten.fitKategorieFinden(kategorie);
    var regelsaetze = daten.regelsaetzeFuer(kategorie);
    var begruendungen = [];

    var leer = {
      kategorie: kategorie,
      empfehlungen: [],
      empfehlung: null,
      massgeblich: null,
      weite: null,
      bewertung: "pruefen",
      begruendungen: begruendungen,
      datenluecke: true
    };

    if (!kat) return leer;

    var fehlende = kat.felder.filter(function (f) {
      return f.pflicht && werte[f.schluessel] === undefined;
    });
    if (fehlende.length > 0) {
      begruendungen.push({ text: "Es fehlt noch: " + fehlende.map(function (f) { return f.label; }).join(", ") + "." });
      return Object.assign({}, leer, { datenluecke: false, begruendungen: begruendungen });
    }

    var belegte = regelsaetze.filter(function (r) {
      return r.groessen.length > 0;
    });
    if (belegte.length === 0) {
      begruendungen.push({
        text:
          "Für diese Kategorie liegt uns keine geprüfte Herstellertabelle vor. Deshalb nennen wir keine Größe, sondern gleichen deine Maße direkt mit den Artikeln ab, die wir selbst vermessen haben."
      });
      return Object.assign({}, leer, { begruendungen: begruendungen });
    }

    var effektiv = Object.assign({}, werte);
    var massgeblich = null;

    if (kategorie === "schlittschuhe") {
      var laenge = laengererFuss(werte);
      if (laenge === null) return Object.assign({}, leer, { datenluecke: false });
      effektiv.fussLinksMm = laenge;
      massgeblich = { schluessel: "fussLinksMm", wertText: mmAlsCm(laenge) + " cm" };

      var links = zahl(werte, "fussLinksMm");
      var rechts = zahl(werte, "fussRechtsMm");
      if (links !== null && rechts !== null && links !== rechts) {
        begruendungen.push({
          text: "Deine Füße unterscheiden sich um " + mmAlsCm(Math.abs(links - rechts)) + " cm. Wir rechnen mit dem längeren (" + mmAlsCm(laenge) + " cm)."
        });
      }
    }

    var empfehlungen = [];
    var bewertungen = [];
    var ohneTreffer = [];

    for (var i = 0; i < belegte.length; i++) {
      var regelsatz = belegte[i];
      var treffer = besteRegel(regelsatz, effektiv);
      if (!treffer) {
        ohneTreffer.push(regelsatz.marke);
        continue;
      }
      empfehlungen.push({
        herstellerGroesse: treffer.regel.herstellerGroesse,
        eu: treffer.regel.eu,
        altersklasse: treffer.regel.altersklasse,
        marke: regelsatz.marke,
        quelle: regelsatz.quelle
      });
      bewertungen.push(treffer.bewertung);

      var bereich = treffer.regel.bereiche;
      var ersterSchluessel = Object.keys(bereich)[0];
      var b = ersterSchluessel ? bereich[ersterSchluessel] : undefined;
      var feld = null;
      for (var j = 0; j < kat.felder.length; j++) {
        if (kat.felder[j].schluessel === ersterSchluessel) {
          feld = kat.felder[j];
          break;
        }
      }

      if (b && ersterSchluessel) {
        var istMm = /Mm$/.test(ersterSchluessel);
        var einheit = istMm ? "cm" : feld && feld.einheit === "kg" ? "kg" : "cm";
        var fmt = function (v) {
          return istMm ? mmAlsCm(v) : String(v);
        };
        begruendungen.push({
          text:
            regelsatz.marke +
            " " +
            treffer.regel.herstellerGroesse +
            ": " +
            (feld ? feld.label : ersterSchluessel) +
            " von " +
            fmt(b.von) +
            " bis " +
            fmt(b.bis) +
            " " +
            einheit +
            (treffer.bewertung === "grenze" ? " — du liegst dicht an der Grenze, die Nachbargröße kann ebenfalls passen." : "."),
          schluessel: ersterSchluessel
        });
      }
    }

    if (ohneTreffer.length > 0) {
      begruendungen.push({ text: "Bei " + ohneTreffer.join(" und ") + " liegen deine Maße außerhalb der hinterlegten Größenbereiche." });
    }

    if (empfehlungen.length === 0) {
      return Object.assign({}, leer, { datenluecke: true, massgeblich: massgeblich, begruendungen: begruendungen });
    }

    var breite = zahl(werte, "fussBreiteMm");
    var weite =
      kategorie === "schlittschuhe" && breite
        ? {
            normalisiert: "unbekannt",
            hinweis:
              "Gemessene Fußbreite " +
              mmAlsCm(breite) +
              " cm. Eine Weite (Fit 1/2/3 bei Bauer, C bis EE bei CCM) leiten wir daraus nicht automatisch ab — dafür haben wir keine belegte Herstellerangabe."
          }
        : null;

    return {
      kategorie: kategorie,
      empfehlungen: empfehlungen,
      empfehlung: empfehlungen[0],
      massgeblich: massgeblich,
      weite: weite,
      bewertung: schlechteste(bewertungen),
      begruendungen: begruendungen,
      datenluecke: false
    };
  }

  window.AsFitEngine = {
    zahl: zahl,
    laengererFuss: laengererFuss,
    mmAlsCm: mmAlsCm,
    bereichPruefen: bereichPruefen,
    schlechteste: schlechteste,
    BEWERTUNG_TEXT: BEWERTUNG_TEXT,
    auswerten: auswerten
  };
})();
